import axios from 'axios';

export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  timeout: 1000 * 30,
});

export const HTTPMentor = axios.create({
  baseURL: process.env.VUE_APP_BASEURL_MENTOR,
  timeout: 1000 * 30,
});

export const HTTPTICKET = axios.create({
    baseURL: process.env.VUE_APP_BASEURL_TICKET,
    timeout: 1000 * 30,
});

export const HTTPDynamic = axios.create({
  baseURL: process.env.VUE_APP_BASEURL_DYNAMIC,
  timeout: 1000 * 30,
});

export const HTTPReview = axios.create({
  baseURL: process.env.VUE_APP_BASEURL_REVIEW,
  timeout: 1000 * 30,
});

// export const LOCALHOST = axios.create({
//   baseURL: process.env.VUE_APP_LOCALHOST,
//   timeout: 1000 * 30,
// });


// WEBPACK FOOTER //
// ./src/axios.js